import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../components/common/Loading';
import Error from '../components/common/Error';
import CustomerUsersList from '../components/rts/CustomerUsers/CustomerUsersList';
import CustomerUsersHeader from '../components/rts/CustomerUsers/CustomerUsersHeader';
import CustomerUsersFilter from '../components/rts/CustomerUsers/CustomerUsersFilter';

import { useSessionContext } from '../contexts/SessionContext';

export default function CustomerUsersPage( props ){
    //console.debug("RTS Break CustomerUsersPage");

    const {curFilter, sessionCustomer, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [filter, setFilter] = useState();
    const [data, setData] = useState([]);


    const fetchData = useCallback((pFilter) => {
        let apiURL = apiRoot + "/AppUserCustomers/GetCustomersAppUsersAccessLevel";
        axios
        .post(
            apiURL,
            pFilter,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token}}
        )
        .then(response => {
            if (response.data) {
                setData(response.data);
            }
            setIsLoading(false);
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status == 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token]);


    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'CustomerUsersPage'){
            setFilter(curFilter.filter);
            fetchData(curFilter.filter);
        }
        else{
            setFilter({customer:sessionCustomer.customer, role:-1});
            fetchData({customer:sessionCustomer.customer, role:-1});
        }
    }, [props, curFilter, fetchData]); 


    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '75vh';
        }
        return retValue;
    }    


     if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    return(
        <Box>
            <CustomerUsersHeader />
            <CustomerUsersFilter filter={filter} setFilterFx={setFilter} />            
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                <CustomerUsersList data={data} />
            </Box>
        </Box>
    );


}
